export default "__VITE_ASSET__aHnivi3E__"